import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=595a96a2&"
import script from "./IconClose.vue?vue&type=script&lang=js&"
export * from "./IconClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('595a96a2')) {
      api.createRecord('595a96a2', component.options)
    } else {
      api.reload('595a96a2', component.options)
    }
    module.hot.accept("./IconClose.vue?vue&type=template&id=595a96a2&", function () {
      api.rerender('595a96a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconClose.vue"
export default component.exports